webpackJsonp([114276838955818,60335399758886],{

/***/ 216:
/***/ (function(module, exports) {

	module.exports = {"data":{"pages":{"edges":[{"node":{"fields":{"slug":"/about/","prefix":"1"},"frontmatter":{"title":"About","menuTitle":null}}},{"node":{"fields":{"slug":"/starters/","prefix":"2"},"frontmatter":{"title":"Other GatsbyJS starters","menuTitle":"Starters"}}},{"node":{"fields":{"slug":"/front-end-dev/","prefix":"3"},"frontmatter":{"title":"Front-end web development with Greg","menuTitle":"With Greg"}}},{"node":{"fields":{"slug":"/privacy/","prefix":"4"},"frontmatter":{"title":"Privacy Policy","menuTitle":null}}},{"node":{"fields":{"slug":"/terms/","prefix":"5"},"frontmatter":{"title":"Terms and Conditions","menuTitle":null}}}]},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Development Fitness Gym</li>\n<li>Telephone #: (323) 620-6247</li>\n<li>Address: 3132 E Chapman Ave, Orange, CA 92869</li>\n<li><a href=\"https://www.yelp.com/biz/development-fitness-gym-orange\">Yelp</a></li>\n<li><a href=\"https://www.facebook.com/Development-Fitness-Gym-198758110770574/\">Facebook</a></li>\n<li><a href=\"instagram.com/developmentfitnessgym\">Instagram</a></li>\n</ul>"}},"layoutContext":{}}

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(43);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(216);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-87309616a06c37280691.js